let language = {
    LOGIN_FORM_EMAIL_LABEL: "Email",
    LOGIN_FORM_EMAIL_INPUT_PLACEHOLDER: "Please input your email address",
    LOGIN_FORM_PASSWORD_LABEL: "Password",
    LOGIN_FORM_PASSWORD_INPUT_PLACEHOLDER: "Please input your password",
    LOGIN_FORM_SUBMIT_BTN: "Sign In",

    LOGIN_FORM_ERROR_TIP1: "Please enter the correct email address",

    LOGIN_FAIL_TIPS_TITLE:"Login Failed",
    LOGIN_FAIL_BUTTON_RETRY:"Retry",
};

export { language }